import {useIntl} from 'react-intl'
import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'
import ProductForm from '../component/New'
import {useGetDetailForNew} from '../context/useQuery'
import {useNavigate} from 'react-router-dom'

export default function ProductNew() {
  const intl = useIntl()
  const {isLoading} = useGetDetailForNew()
  const navigate = useNavigate()

  return (
    <>
      <div className='d-flex gap-5 align-items-center'>
        <button
          className='btn btn-primary btn-sm btn-back'
          onClick={() => {
            navigate('/products')
          }}
        >
          <i className='fa fa-arrow-left '></i>
        </button>
        <BreadCrumb currentPage={intl.formatMessage({id: 'PRODUCT.NEW'})} />
      </div>
      <div id='kt_app_content_container' className='d-flex flex-column flex-root mt-10'>
        <ProductForm />
      </div>
    </>
  )
}
